export enum LocalStorageKey {
  QueryEditorPreferences = "query_editor.preferences",
  ChatWaitingQueries = "query_editor.chat_waiting_queries",
}

export class LocalStorage {
  static save<T extends object>(key: LocalStorageKey, value: T) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  static load(key: LocalStorageKey): unknown {
    let value: unknown = {};
    try {
      value = JSON.parse(localStorage.getItem(key) || "{}");
    } catch {
      // noop
    }
    return value;
  }
}
